/** Category tabs — order matches typical filter priority. */
export const EVENT_CATEGORY_TABS = [
  { key: "club", label: "Club" },
  { key: "booth", label: "Booth" },
  { key: "event", label: "Event" },
  { key: "vip", label: "VIP Entry" },
  { key: "table", label: "Table" },
];

/** Dynamic heading above the list, e.g. "Table (3)" */
export function getCategorySectionTitle(tabKey) {
  const found = EVENT_CATEGORY_TABS.find((t) => t.key === tabKey);
  return found ? found.label : "Events";
}
